<div class="editor-container" #editorContainer>
    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
    <ngx-editor class="resizable-editor" (focusOut)="onTouched()" (ngModelChange)="onInputChange($event)"
        (paste)="onPaste($event)" [editor]="editor" [(ngModel)]="htmlContent" [disabled]="false"
        [placeholder]="'Enter student feedback...'"></ngx-editor>
</div>